import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const ExportIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentcolor">
            {/* eslint-disable-next-line max-len */}
            <path d="M10.0001 12.9808L7.05133 10.032L7.64112 9.43267L9.58342 11.375V4.16663H10.4167V11.375L12.359 9.43267L12.9488 10.032L10.0001 12.9808ZM4.16675 15.8333V12.4679H5.00008V15H15.0001V12.4679H15.8334V15.8333H4.16675Z"/>
        </svg>
    </IconWrapper>
));
